"use client";

import React from "react";
import { Play, ShieldCheck, Zap, Clock, Loader, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
export default function HopeBeginsWithBasket() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    label: "عاماً من الخبرة",
    value: "+15",
    icon: <Clock className="w-5 h-5" />
  }, {
    label: "ضمان الجودة",
    value: "100%",
    icon: <ShieldCheck className="w-5 h-5" />
  }, {
    label: "دعم فني مباشر",
    value: "24/7",
    icon: <Zap className="w-5 h-5" />
  }];
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "سرايا لمكافحة الحشرات",
    "description": "شركة سرايا تقدم حلولاً هندسية متكاملة لمكافحة الآفات في الرياض بأحدث التقنيات العالمية.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "الرياض",
      "addressCountry": "SA"
    },
    "areaServed": "الرياض",
    "priceRange": "$$"
  };
  return <section data-section-id="227202" id="التميز-في-إبادة-الحشرات" className="relative bg-gradient-to-br from-primary via-primary/80 to-secondary text-foreground overflow-hidden py-24 md:py-32 lg:py-40 dark">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} />
      
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--accent),transparent_50%)] opacity-[0.08] pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--text-dark)]/30 via-transparent to-[var(--primary)] pointer-events-none" />
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]" />

      <div className="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-start">
          
          <div ref={textRef} className={`flex flex-col justify-center space-y-10 transition-all duration-400 ease-out transform text-right items-end ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="space-y-6">
              <div className="inline-flex items-center gap-3 px-5 py-2 rounded-full bg-accent/10 border border-accent/20 text-accent text-sm font-bold mb-4 backdrop-blur-sm">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-accent"></span>
                </span>
                الريادة في مكافحة الآفات بالرياض
              </div>
              
              <h1 className="font-primary text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] tracking-tighter text-right">
                حماية ذكية <br />
                <span className="text-accent drop-shadow-[0_0_15px_rgba(var(--accent),0.3)]">لبيئة آمنة</span>
              </h1>
              
              <p className="text-lg md:text-xl text-[var(--text-light)]/80 max-w-xl leading-relaxed font-primary text-right">
                شركة سرايا تقدم حلولاً هندسية متكاملة لمكافحة الآفات. نجمع بين الخبرة الفنية وأحدث التقنيات العالمية لضمان منشأة خالية تماماً من الحشرات بضمانات حقيقية ونتائج فورية.
              </p>
            </div>

            <div className="w-full max-w-md">
              <FormProvider formId="quote_form_home" sectionName="hero-section" defaultValues={{
              full_name: "",
              phone_number: ""
            }} className="bg-secondary/80 backdrop-blur-md border border-white/10 p-6 rounded-lg shadow-xl">
                <QuoteForm />
              </FormProvider>
              
              <div className="mt-4 flex items-center justify-end gap-2 text-[var(--text-light)]/90 font-bold">
                <Link to="https://wa.me/966505276652" newTab className="text-accent hover:underline transition-all">
                  0505276652
                </Link>
                <Phone className="w-5 h-5 text-accent" />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row-reverse gap-5 pt-4 justify-start w-full sm:w-auto">
              <Button size="lg" className="text-lg h-16 px-10 rounded-full shadow-lg hover:shadow-accent/30 transition-all bg-accent text-primary font-bold border-none hover:scale-105 active:scale-95" asChild>
                <Link to="/HomePage">طلب معاينة مجانية</Link>
              </Button>
              
              <Button variant="outline" size="lg" className="text-lg h-16 px-10 rounded-full gap-3 bg-[var(--text-light)]/5 backdrop-blur-xl border-[var(--text-light)]/10 hover:bg-[var(--text-light)]/10 transition-all text-[var(--text-light)] font-primary hover:scale-105 active:scale-95" asChild>
                <Link to="/HomePage">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-accent/20 text-accent">
                    <Play className="w-4 h-4 fill-current" />
                  </span>
                  استكشف خدماتنا
                </Link>
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-10 border-t border-white/10 w-full">
              {stats.map((stat, i) => <div key={i} data-index={i} className="text-right space-y-1">
                  <div className="flex items-center justify-end gap-2 text-accent mb-1">
                    {stat.icon}
                  </div>
                  <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
                  <div className="text-xs text-white/50 uppercase tracking-wider font-medium">{stat.label}</div>
                </div>)}
            </div>
          </div>

          <div ref={imgRef} className={`relative transition-all duration-400 ease-out delay-200 transform ${isImgVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="absolute -bottom-12 -right-12 w-[40%] sm:w-[50%] lg:w-[600px] h-[64px] sm:h-[300px] lg:h-[400px] bg-accent/20 rounded-full blur-[100px] opacity-40 -z-10" />
            <div className="absolute -top-12 -left-12 w-[40%] sm:w-[50%] lg:w-[600px] h-[64px] sm:h-[300px] lg:h-[400px] bg-[var(--text-light)]/5 rounded-full blur-[120px] opacity-30 -z-10" />

            <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square bg-secondary border border-[var(--text-light)]/10 group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/industrial_pest_control_noir.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/industrial_pest_control_noir.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/industrial_pest_control_noir.png-wvc-sizes" alt="أخصائي مكافحة حشرات من شركة سرايا يعمل في موقع صناعي" className="w-full h-full object-cover grayscale contrast-125 transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              
              <div className="absolute inset-0 bg-accent/5 mix-blend-overlay pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary via-transparent to-transparent opacity-90 pointer-events-none" />
              
              <div className="absolute bottom-8 right-8 left-8 p-5 rounded-lg bg-secondary/80 backdrop-blur-md border border-white/10 flex items-center justify-between shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center text-accent">
                    <ShieldCheck className="w-6 h-6" />
                  </div>
                  <div className="text-right">
                    <div className="text-[var(--text-light)] font-bold text-sm">خدمة معتمدة</div>
                    <div className="text-white/60 text-xs">مطابق للمواصفات العالمية ISO</div>
                  </div>
                </div>
                <div className="hidden sm:block">
                  <div className="px-3 py-1 rounded-full bg-success/20 text-success text-[10px] font-bold uppercase tracking-tighter">
                    نشط الآن
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}
function QuoteForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const onSubmit = (data: any) => {
    const businessNumber = "966505276652";
    const message = `اسم: ${data.full_name}, رقم الجوال: ${data.phone_number}`;
    const whatsappUrl = `https://wa.me/${businessNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-success/10 border border-success/20 rounded-lg text-center space-y-4">
        <p className="text-success font-bold">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="rounded-full border-success/20 text-success hover:bg-success/10">
          إرسال طلب آخر
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <FormField control={control} name="full_name" rules={{
      required: "الاسم مطلوب"
    }} render={({
      field
    }) => <FormItem className="text-right">
            <FormLabel className="text-[var(--text-light)]/70 text-sm">الاسم الكامل</FormLabel>
            <FormControl>
              <Input placeholder="أدخل اسمك" className="h-12 rounded-lg bg-[var(--text-light)]/5 border-[var(--text-light)]/10 text-[var(--text-light)] placeholder:text-[var(--text-light)]/30 focus:border-accent/50 transition-colors" {...field} />
            </FormControl>
            <FormMessage className="text-xs text-destructive" />
          </FormItem>} />

      <FormField control={control} name="phone_number" rules={{
      required: "رقم الهاتف مطلوب"
    }} render={({
      field
    }) => <FormItem className="text-right">
            <FormLabel className="text-[var(--text-light)]/70 text-sm">رقم الهاتف</FormLabel>
            <FormControl>
              <Input placeholder="05xxxxxxxx" className="h-12 rounded-lg bg-[var(--text-light)]/5 border-[var(--text-light)]/10 text-[var(--text-light)] placeholder:text-[var(--text-light)]/30 focus:border-accent/50 transition-colors" {...field} />
            </FormControl>
            <FormMessage className="text-xs text-destructive" />
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive text-xs text-center">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 rounded-full bg-accent text-primary font-bold text-lg hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-accent/20 flex items-center justify-center gap-2">
        {isSubmitting ? <>
            <Loader className="animate-spin size-5" />
            جاري الإرسال...
          </> : <>
            <MessageCircle className="size-5" />
            إرسال عبر واتساب
          </>}
      </Button>
    </Form>;
}